const win = {
    closeWindow() {
        return (parent.window || window).win.closeWindow();
    }
};
export default win;
